import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-confirm-icon",
  "use": "icon-confirm-icon-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-confirm-icon\">\n  <path d=\"M428.8 697.248c-3.84-2.496-58.88-57.216-165.12-164.128a32 32 0 0 1 45.12-45.12l137.28 137.28 265.6-265.6a32 32 0 0 1 45.12 45.12l-287.744 287.776c-5.824 6.08-12.32 11.296-21.056 11.424-8.736 0.128-13.44-3.008-19.2-6.752z\" fill=\"\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol